import React from 'react';
import { SkeletonComponent } from '@design-system';

export const GenericCategorySkeleton: React.FC = () => {
    return (
        <>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '120px',
                        width: '120px',
                        borderRadius: '12px',
                        margin: '0 8px 8px 0'
                    }}
                />
            ))}
        </>
    );
};
